import { render } from "./NewSponsorDialog.vue?vue&type=template&id=a8337514&scoped=true"
import script from "./NewSponsorDialog.vue?vue&type=script&lang=js"
export * from "./NewSponsorDialog.vue?vue&type=script&lang=js"

import "./NewSponsorDialog.vue?vue&type=style&index=0&id=a8337514&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8337514"]])

export default __exports__